export const normalizarParaPonto = (valor: string): string => {
    if (!valor) return ""
    let textoNormalizado = String(valor)
        .replace(/\s/g, "")
        .replace(/[^\d.,]/g, "")
    if (textoNormalizado.includes(",")) {
        textoNormalizado = textoNormalizado.replace(/\./g, "").replace(",", ".")
    }
    return textoNormalizado
}

export const formatValorUnitarioParaView = (valor: string): string => {
    const normalizado = normalizarParaPonto(valor)
    if (!normalizado) return ""
    const [parteInteiraBruta, parteFracionariaBruta = ""] = normalizado.split(".")
    const parteInteiraNumerica = (parteInteiraBruta || "0").replace(/^0+(?=\d)/, "") || "0"
    let parteFracionaria = parteFracionariaBruta.slice(0, 6).replace(/0+$/, "")
    if (parteFracionaria.length < 2) parteFracionaria = parteFracionaria.padEnd(2, "0")
    const parteInteiraComMilhar = parteInteiraNumerica.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    return `${parteInteiraComMilhar},${parteFracionaria}`
}

export const formatarValorParaEnviar = (valor: string): string => {
    const normalizado = normalizarParaPonto(valor)
    if (!normalizado) return ""
    const [parteInteiraBruta, parteFracionariaBruta = ""] = normalizado.split(".")
    const parteInteira = (parteInteiraBruta || "0").replace(/^0+(?=\d)/, "") || "0"
    const parteFracionaria = parteFracionariaBruta.slice(0, 6).padEnd(6, "0")
    return `${parteInteira}.${parteFracionaria}`
}
